import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import Logo from "./Logo";
import { cn } from "@/lib/utils";

const NAV_LINKS = [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Why Us", href: "#why" },
    { label: "Process", href: "#process" },
    { label: "Contact", href: "#contact" }
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            id="top"
            className={cn(
                "fixed top-0 inset-x-0 z-50 transition-smooth",
                scrolled
                    ? "bg-background/85 backdrop-blur-md border-b border-border"
                    : "bg-transparent border-b border-transparent"
            )}
        >
            <div className="container-px mx-auto max-w-7xl flex items-center justify-between h-16 lg:h-[72px]">
                <Logo />

                <nav className="hidden md:flex items-center gap-1">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            className="px-3.5 py-2 rounded-md text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-2">
                    <Button asChild variant="ghost" size="sm" className="text-foreground hover:bg-muted">
                        <a href="mailto:info@zaroorglobaltrading.com">info@zaroorglobaltrading.com</a>
                    </Button>
                    <Button asChild size="sm" className="bg-primary text-primary-foreground hover:bg-primary-variant">
                        <a href="#contact">
                            Partner With Us <ArrowUpRight className="w-4 h-4" />
                        </a>
                    </Button>
                </div>

                <div className="md:hidden flex items-center">
                    <Sheet open={open} onOpenChange={setOpen}>
                        <SheetTrigger asChild>
                            <Button variant="ghost" size="icon" aria-label="Open menu">
                                {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                            </Button>
                        </SheetTrigger>
                        <SheetContent side="right" className="w-[86%] max-w-sm border-l border-border">
                            <div className="flex flex-col h-full">
                                <Logo />
                                <nav className="mt-10 flex flex-col gap-1">
                                    {NAV_LINKS.map((l) => (
                                        <a
                                            key={l.href}
                                            href={l.href}
                                            onClick={() => setOpen(false)}
                                            className="px-3 py-3 rounded-md text-base font-medium text-foreground hover:bg-muted transition-smooth"
                                        >
                                            {l.label}
                                        </a>
                                    ))}
                                </nav>
                                <div className="mt-auto pt-8 flex flex-col gap-3">
                                    <Button asChild className="bg-primary text-primary-foreground hover:bg-primary-variant">
                                        <a href="#contact" onClick={() => setOpen(false)}>
                                            Partner With Us
                                        </a>
                                    </Button>
                                    <a
                                        href="mailto:info@zaroorglobaltrading.com"
                                        className="text-sm text-muted-foreground text-center"
                                    >
                                        info@zaroorglobaltrading.com
                                    </a>
                                </div>
                            </div>
                        </SheetContent>
                    </Sheet>
                </div>
            </div>
        </header>
    );
}
